import { format, parseISO } from 'date-fns';

function formatOutcomeLabel(outcome, status) {
  if (outcome) return String(outcome).replace(/_/g, ' ');
  if (status) return String(status).replace(/_/g, ' ');
  return 'pending';
}

function formatAppointmentTime(details) {
  if (!details || typeof details !== 'object') return '—';
  const scheduledRaw = details.scheduled_time ?? details.scheduled_at ?? details.start_time;
  if (typeof scheduledRaw !== 'string' || !scheduledRaw.trim()) return '—';
  try {
    const d = parseISO(scheduledRaw.trim());
    if (Number.isNaN(d.getTime())) return scheduledRaw;
    return format(d, 'MMM d, yyyy h:mm a');
  } catch {
    return scheduledRaw;
  }
}

/** Build activity-feed items from thoughtly_calls rows. */
export function buildThoughtlyActivityItems(calls = []) {
  const items = [];
  for (const call of calls) {
    const ts = call.updated_at || call.created_at;
    const user = call.triggered_by_user;

    items.push({
      type: 'thoughtly',
      id: `thoughtly-call-${call.id}`,
      subtype: 'call',
      activity_at: ts,
      user,
      outcomeLabel: formatOutcomeLabel(call.outcome, call.status),
    });

    if (call.appointment_booked) {
      items.push({
        type: 'thoughtly',
        id: `thoughtly-appt-${call.id}`,
        subtype: 'appointment',
        activity_at: ts,
        user,
        scheduledLabel: formatAppointmentTime(call.appointment_details),
      });
    }
  }
  return items;
}
